<template>
  <div class="mx-auto">
    <v-dialog
      v-model="showAdd"
      class="dialogShow"
      max-width="700px"
      style="overflow-x: hidden"
      persistent
      return-value="value"
      :key="formKey"
    >
      <AddEmployee />
    </v-dialog>
    <v-card class="ma-0 pa-0">
      <v-card-title
        style="background-color: #82a1d0; position: sticky; top: 0; z-index: 0"
        background-color="primary"
        class="d-flex justify-space-between align-center"
      >
        <v-row>
          <div class="filter-search-container mx-3">
            <div class="filter-container mx-1">
              <v-menu v-model="menu" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" class="filter-btn" icon>
                    <v-icon color="blue-grey darken-1"
                      >mdi-filter-variant</v-icon
                    >
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="option in filterOptions"
                    :key="option.value"
                    @click="setFilter(option.value)"
                  >
                    <v-list-item-title>{{ option.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="search-container">
              <v-text-field
                v-if="selectedFilter !== 'etiqueta'"
                dense
                solo
                v-model="filterValue"
                :key="selectedFilter"
                :placeholder="currentPlaceholder"
                append-icon="mdi-magnify"
                single-line
                hide-details
                class="search"
                flat
                @keyup.enter="applyFilter"
                :readonly="!selectedFilter"
                @click="activeMenu()"
              />
              <v-autocomplete
                v-else
                v-model="selected"
                small-chips
                dense
                solo
                flat
                hide-details
                append-icon="mdi-tag-multiple"
                :label="$tc('commons.group')"
                class="autocomplete"
                :items="getTags"
                item-text="text"
                item-value="id"
                @input="changesTags()"
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    v-if="selected !== null"
                    :color="item.color"
                    id="chip-tag"
                    small
                    close
                    @click:close="selected = null"
                  >
                    <span>{{ item.text }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-chip id="chip-tag" small :color="item.color">
                    {{ item.text }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  @click="resetFilter"
                  :disabled="!selectedFilter && !filterValue"
                  class="reset-btn mx-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{ $tc("gestionEmpleados.resetFilter") }}</span>
            </v-tooltip>
          </div>
          <div class="filter-search-container">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="handleItemsSelect"
                  color="blue-grey darken-1"
                  icon
                  class="ml-1"
                  :disabled="
                    !verifyExistingAction('accion:modificaretiquetasempleado')
                  "
                >
                  <v-icon>mdi-tag-plus</v-icon>
                </v-btn>
              </template>
              <span>Asignar etiquetas</span>
            </v-tooltip>
            <v-dialog v-model="tagDialog" max-width="400px">
              <v-card class="pa-0">
                <v-card-title class="d-flex justify-center">
                  {{
                    showAddTag === false
                      ? "Asignar etiquetas"
                      : "Agregar etiqueta nueva"
                  }}
                </v-card-title>
                <v-tooltip bottom v-if="!showAddTag">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      class="add-tag"
                      v-bind="attrs"
                      v-on="on"
                      @click="showAddTag = true"
                      >mdi-tag-plus</v-icon
                    >
                  </template>
                  <span>Agregar etiqueta</span>
                </v-tooltip>

                <v-card-text :class="{ 'mt-n5': showAddTag == false }">
                  <v-form ref="form" v-model="formValid" v-if="!showAddTag">
                    <v-autocomplete
                      v-model="selectedRow"
                      :items="getEmployees"
                      item-value="id"
                      item-text="fullName"
                      label="Selecciona un empleado"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Este campo es requerido']"
                      :search-input.sync="searchEmployeed"
                    />
                    <v-autocomplete
                      v-model="selectedTagsGroup"
                      :items="getTagsFilter(selectedRow)"
                      item-value="id"
                      item-text="text"
                      label="Selecciona etiquetas"
                      multiple
                      outlined
                      dense
                      chips
                      :rules="[
                        (v) =>
                          (!!v && v.length > 0) || 'Este campo es requerido',
                      ]"
                      :search-input.sync="searchTag"
                      :disabled="!selectedRow"
                    >
                      <template v-slot:item="data">
                        <div style="display: flex; align-items: center">
                          <div
                            :style="{
                              backgroundColor: data.item.color,
                              width: '20px',
                              height: '20px',
                              marginRight: '10px',
                            }"
                          ></div>
                          <span>{{ data.item.text }}</span>
                        </div>
                      </template>
                      <template v-slot:selection="data">
                        <v-chip
                          :key="data.item.id"
                          :color="data.item.color"
                          text-color="white"
                          close
                          small
                          @click:close="removeTag(data.item)"
                        >
                          {{ data.item.text }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-form>
                  <v-form ref="form" v-model="formValid" v-else>
                    <v-text-field
                      name="text"
                      v-model="name"
                      :label="this.$tc('reports.labelsTitle')"
                      outlined
                      :rules="rules"
                      dense
                      class="ma-0"
                    />
                    <v-text-field
                      name="description"
                      v-model="description"
                      :label="this.$tc('reports.labelsDescription')"
                      outlined
                      :rules="rules"
                      dense
                      class="ma-0"
                    />
                    <v-color-picker
                      v-model="color"
                      class="mx-auto mb-4"
                      :swatches="swatches"
                      show-swatches
                      hide-canvas
                      hide-sliders
                      hide-inputs
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-space-between mt-n5">
                  <v-btn
                    color="red"
                    text
                    @click="cancelDialogTag"
                    v-if="!showAddTag"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn color="red" text @click="showAddTag = false" v-else
                    >Cancelar</v-btn
                  >
                  <v-btn
                    color="primary"
                    text
                    @click="validateAndSave"
                    :disabled="!formValid"
                    v-if="!showAddTag"
                  >
                    Aceptar
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="addTag()"
                    :disabled="!formValid"
                    v-else
                  >
                    Aceptar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-row>

        <v-col cols="auto" class="my-n4 pr-0">
          <v-row class="justify-start border ma-0">
            <!-- Botón de Refresh -->
            <v-col cols="auto" class="pa-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="refreshItems"
                    class="btn-table ma-1"
                    small
                  >
                    <v-icon
                      :class="{ loader: loading4 }"
                      :loading="loading4"
                      :disabled="loading4"
                      id="icon-add"
                      class="mx-auto"
                      size="19"
                    >
                      fas fa-sync-alt
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("commons.refresh") }}</span>
              </v-tooltip>
            </v-col>
            <!-- Botón de Configurar Columnas -->
            <v-col cols="auto pa-0">
              <div class="d-flex justify-center">
                <v-dialog
                  v-model="btnConfigColumns.menu"
                  max-width="400px"
                  @keydown.esc="toggleColumnMenu"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="white"
                          dark
                          icon
                          @click="toggleColumnMenu"
                          v-bind="attrs"
                          v-on="on"
                          class="btn-table ma-1"
                          small
                        >
                          <v-icon size="20">{{ btnConfigColumns.icon }}</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ btnConfigColumns.tooltip }}</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <div class="d-flex align-center">
                      <v-text-field
                        v-model="columnFilter"
                        placeholder="Buscar columnas"
                        outlined
                        dense
                        hide-details
                        class="pa-2 pb-0 ma-0 flex-grow-1"
                      ></v-text-field>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            class="pt-2 ma-0 pb-0 hover-effect"
                            v-bind="attrs"
                            v-on="on"
                            @click="resetColumnsOrder"
                          >
                            <v-icon size="27" class="hover-icon"
                              >mdi-restore</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Restablecer orden</span>
                      </v-tooltip>
                    </div>
                    <div
                      style="
                        min-width: 250px;
                        max-height: 250px;
                        overflow-y: scroll;
                        scrollbar-width: unset;
                      "
                      class="pa-2 pb-0 ma-0"
                      hide-details
                    >
                      <div
                        v-if="filteredColumns?.length === 0"
                        class="text-center px-2 pb-2"
                      >
                        <span
                          >No hay resultados que coincidan con la búsqueda</span
                        >
                      </div>
                      <div v-else>
                        <div
                          v-for="(column, index) in visibleHeaders"
                          :key="column.field"
                          draggable="true"
                          @dragstart="dragStart(index)"
                          @dragover.prevent
                          @drop="drop(index)"
                          class="d-flex align-center draggable-item"
                        >
                          <v-icon class="mr-2">mdi-drag</v-icon>
                          <v-checkbox
                            v-model="column.visible"
                            :label="column.text"
                            hide-details
                            class="my-auto mb-2"
                          ></v-checkbox>
                        </div>
                      </div>
                    </div>
                    <v-card-actions class="d-flex justify-space-between">
                      <v-btn class="bt-exit" @click="toggleColumnMenu">
                        <v-icon>fas fa-times</v-icon>
                      </v-btn>
                      <v-btn
                        color="bt-acept"
                        @click="
                          saveConfigColumns();
                          toggleColumnMenu();
                        "
                      >
                        <v-icon>fas fa-save</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-col>
            <!-- Botón de Añadir -->
            <v-col cols="auto pa-0">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="white" dark icon class="btn-table ma-1" small>
                      <v-icon
                        size="20"
                        class="mx-auto"
                        id="icon-add"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialog()"
                        :disabled="
                          !verifyExistingAction('accion:agregarempleado')
                        "
                      >
                        fas fa-plus
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $tc("commons.add") }}</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <!--         <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                id="icon-add"
                v-bind="attrs"
                v-on="on"
                @click="openDialog('add')"
              >
                fas fa-plus-circle
              </v-icon>
            </template>
            <span>{{ $tc("commons.add") }}</span>
          </v-tooltip>
        </div> -->
      </v-card-title>
      <v-divider></v-divider>

      <v-data-table
        :search="search"
        :hide-default-footer="true"
        :no-data-text="$tc('editRegistrations.notData')"
        disable-pagination
        :headers="visibleHeaders"
        :items="getEmployees"
        class="ma-0 pa-0"
        v-sortable-columns="saveColumnOrder"
        :key="tableKey"
        item-key="id"
        fixed-header
        :height="calculateMaxHeight"
      >
        <!-- @click:row="employedSelected" -->
        <template v-slot:header.actions="{ header }">
          <span class="d-flex justify-center">
            {{ header.text }}
          </span>
        </template>
        <template v-slot:[`item.image`]="{ item }">
          <div class="p-2">
            <v-img
              :src="item.preview"
              :alt="item.preview"
              style="width: 50px; height: 50px; border-radius: 50%"
            ></v-img>
          </div>
        </template>
        <template v-slot:[`item.isEnabled`]="{ item }">
          <div class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon :color="stateColor(item)">
                    {{ stateIcon(item).icon }}
                  </v-icon>
                </span>
              </template>
              <span>{{ stateTooltip(item) }}</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:[`item.tags`]="{ item }">
          <div
            class="d-flex justify-center"
            v-for="(tag, index) in item.tags"
            :key="index"
          >
            <v-chip :color="tag.color" small id="chip-tag">
              {{ tag.nombre }}
            </v-chip>
          </div>
        </template>

        <template v-slot:header.actions="{ header }">
          <span class="d-flex justify-center">
            {{ header.text }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon
                    @click="goToMonthlyRecord(item)"
                    id="icon-edit"
                    class="mr-3"
                    :disabled="
                      !verifyExistingAction('accion:fichamensualempleado')
                    "
                    >fas fa-calendar</v-icon
                  >
                </span>
              </template>
              <span>{{ $tc("monthlyRecord.monthlyRecord") }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.downDate === null">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon
                    @click="goToFormEnrollment(item)"
                    id="icon-edit"
                    class="mr-3"
                    :disabled="
                      !verifyExistingAction('accion:enrolamientoempleado')
                    "
                    >fas fa-fingerprint</v-icon
                  >
                </span>
              </template>
              <span>{{ $tc("gestionEmpleados.showEnrollment") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon
                    id="icon-edit"
                    @click="employedSelected(item)"
                    :disabled="
                      !verifyExistingAction('accion:modificarempleado')
                    "
                  >
                    fas fa-pen
                  </v-icon>
                </span>
              </template>
              <span>{{ $tc("editRegistrations.edit") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="showMonthlyRecord" max-width="1000" fullscreen>
      <Calendar @close="closeDialog" />
    </v-dialog>

    <v-dialog
      v-model="showUserNotExist"
      @keydown.esc="cancelChanged"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title class="d-flex justify-center">
          {{ this.$tc("gestionEmpleados.userNotExist") }}
        </v-card-title>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn class="bt-acept-blue" @click="closeDialog">{{
            this.$tc("newController.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="thereIsNoInterfaceDevice"
      @keydown.esc="cancelChanged"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title class="d-flex justify-center">
          {{ this.$tc("gestionEmpleados.thereIsNoInterfaceDevice") }}
        </v-card-title>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn class="bt-acept-blue" @click="closeDialog">{{
            this.$tc("newController.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showFormEnrollment"
      @keydown.esc="cancelChanged"
      persistent
      max-width="700px"
    >
      <FormEnrollment
        :key="formKeyEnrollement"
        @cancel="closeDialog"
        @save="confirmEnroll"
        :employeed="employeed"
      />
    </v-dialog>
    <v-dialog
      @keydown.esc="cancelChanged"
      persistent
      max-width="500px"
      v-model="showDialog"
    >
      <DialogConfirm
        :titleChanged="titleChanged"
        @confirmChanged="confirmChanged"
        @cancelChanged="cancelChanged"
      />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </div>
</template>

<script>
import Sortable from "sortablejs";
import AddEmployee from "./Employee/AddEmployee.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import DialogConfirm from "./DialogConfirm.vue";
import moment from "moment";
import Calendar from "./Calendar.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import FormEnrollment from "./FormEnrollment.vue";
import { getConfig } from "@/config";

export default {
  components: {
    AddEmployee,
    DialogConfirm,
    Calendar,
    Snackbar,
    FormEnrollment,
  },
  data() {
    return {
      draggedIndex: null,
      showMonthlyRecord: false,
      calendarDate: moment().startOf("month").format("YYYY-MM-DD"),
      formKey: 0,
      loader: null,
      loading4: false,
      loading: false,
      titleChanged: "",
      employedChanged: null,
      showDialog: false,
      title: this.$tc("gestionEmpleados.title"),
      search: "",
      tableKey: 0,
      btnConfigColumns: {
        menu: false,
        icon: "mdi-cog",
        tooltip: "Columnas",
      },
      columnFilter: "",
      headers: [
        {
          text: "Id",
          value: "empId",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Nombre",
          value: "fullName",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Empleado",
          value: "image",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Legajo",
          value: "file",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tipo Doc",
          value: "typeDoc",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Documento",
          value: "numDoc",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Alta",
          value: "formatHighDate",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Baja",
          value: "formatDownDate",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Estado",
          value: "isEnabled",
          class: "primary secondary--text",
          visible: true,
          width: "80px",
        },
        {
          text: "Etiquetas",
          value: "tags",
          class: "primary secondary--text",
          visible: true,
          width: "100px",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      menu: false,
      filterOptions: [
        { text: "Nombre", value: "nombre" },
        { text: "Apellido", value: "apellido" },
        { text: "Nombre y Apellido", value: "nombre+apellido" },
        { text: "Legajo", value: "legajo" },
        { text: "Número de Documento", value: "ndoc" },
        { text: "Etiqueta", value: "etiqueta" },
        { text: "Activos", value: "activos" },
      ],
      selected: null,
      tagDialog: false,
      formValid: false,
      selectedTagsGroup: [],
      searchTag: "",
      selectedRow: null,
      searchEmployeed: "",
      tagSelected: null,
      showAddTag: false,
      swatches: [
        ["#E10000", "#AA0000", "#550000", "#FF00F1"],
        ["#EAEA12", "#AAAA00", "#555500", "#CD00FF"],
        ["#07B207", "#009000", "#005500", "#800080"],
        ["#32D4D4", "#00AAAA", "#005555", "#373BA8"],
        ["#0000CD", "#0000AA", "#000055", "#4500FF"],
      ],
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      name: "",
      description: "",
      color: "#E10000",
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      alert: false,
      textAlert: "",
      openMenus: {},
      showFormEnrollment: false,
      showUserNotExist: false,
      thereIsNoInterfaceDevice: false,
      formKeyEnrollement: 0,
      employeed: null,
      _config: null,
      selectedActive: false,
    };
  },
  computed: {
    config() {
      if (!this._config) {
        const cfg = getConfig();
        if (!cfg) throw new Error("Config not loaded");
        this._config = cfg;
      }
      return this._config;
    },
    getTags() {
      return this.$store.state.tags.tags.filter(
        (tag) => tag.scope === "empleados"
      );
    },
    showAdd: {
      get() {
        return this.$store.state.employees.showAdd;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    visibleHeaders() {
      return this.allHeaders.filter((column) => column.visible);
    },
    getEmployees() {
      return this.$store.state.employees.employees || [];
    },
    showAdd: {
      get() {
        return this.$store.state.employees.showAdd;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.allHeaders.filter((column) => {
        return column.text.toLowerCase().includes(filterText);
      });
    },

    calculateMaxHeight() {
      return this.getEmployees?.length >= 10 ? "62vh" : "auto";
    },

    currentPlaceholder() {
      return this.$store.getters["employees/currentPlaceholder"];
    },
    selectedFilter() {
      return this.$store.state.employees.selectedFilter;
    },
    filterValue: {
      get() {
        return this.$store.state.employees.filterValue;
      },
      set(newvalue) {
        this.$store.state.employees.filterValue = newvalue;
      },
    },
  },
  mounted() {
    this.$store.dispatch("tags/getTags");
    configTable.commit("setColums", []);
    let nameTable = this.title;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },

  methods: {
    async goToFormEnrollment(item) {
      this.formKeyEnrollement++;
      this.loading = true;
      this.employeed = item;
      if (this.config.enroll) {
        if (this.config.enroll === "suprema") {
          const userExists = await this.$store.dispatch(
            "employees/getInfoUser",
            item.empId
          );
          if (userExists) {
            this.showFormEnrollment = true;
          } else {
            this.showUserNotExist = true;
          }
        }
      } else {
        this.thereIsNoInterfaceDevice = true;
      }
    },
    confirmEnroll() {
      this.showFormEnrollment = false;
      this.loading = false;
      this.showAlert(this.$tc("enrollement.addEnrollementSuccess"), "#82A1D0");
    },
    verifyExistingAction(accion) {
      if (typeof localStorage !== "undefined") {
        const asegurables =
          JSON.parse(localStorage.getItem("asegurables")) || [];
        return asegurables.includes(accion);
      }

      return false;
    },

    getTagsFilter(employeed) {
      let tagsFilter = [];

      const employees = this.getEmployees || [];
      const tags = this.getTags || [];

      const empSelected = employees.find((emp) => emp.id === employeed);

      if (empSelected && Array.isArray(empSelected.tags)) {
        tagsFilter = tags.filter(
          (tag) =>
            !empSelected.tags.some((empTag) => empTag.etiquetaId === tag.id)
        );
      } else {
        // Si no hay empleado o no tiene tags definidos, devolvemos todos los tags
        tagsFilter = tags;
      }

      return tagsFilter;
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    resetColumnsOrder() {
      configTable.state.colums = [...this.headers];
      this.saveConfigColumns();
    },
    dragStart(index) {
      this.draggedIndex = index;
    },
    drop(targetIndex) {
      if (this.draggedIndex === null || this.draggedIndex === targetIndex) {
        console.log(
          "⚠️ Drop cancelado (índices iguales o `draggedIndex` es `null`)"
        );
        return;
      }

      // Hacemos una copia del array para manipularlo
      const updatedHeaders = [...configTable.state.colums];
      const [movedItem] = updatedHeaders.splice(this.draggedIndex, 1);

      updatedHeaders.splice(targetIndex, 0, movedItem);

      // Asignamos el nuevo orden
      configTable.state.colums = updatedHeaders;

      // Resetear estado
      this.draggedIndex = null;
    },
    async addTag() {
      let payload = {
        nombre: this.name,
        descripcion: this.description,
        color: this.color,
        alcance: "empleados",
      };

      await this.$store.commit("tags/setNewTag", payload);
      await this.$store.dispatch("tags/addTag");
      let tagAdd = this.getTags.find((tag) => tag.text === this.name);

      this.selectedTagsGroup = [tagAdd.id];
      this.name = "";
      this.description = "";
      this.color = "#E10000";
      this.showAddTag = false;
    },
    async changesTags() {
      if (this.selected !== null) {
        let where = {
          etiqueta: this.selected,
        };
        await this.$store.dispatch("employees/updateWhere", where);
      }
    },
    activeMenu() {
      if (this.selectedFilter === null) {
        this.menu = true;
      }
    },
    handleItemsSelect() {
      this.tagDialog = true;
    },
    cancelDialogTag() {
      this.tagDialog = false;
      this.$refs.form.reset();
      this.selectedRow = null;
      this.selectedTagsGroup = [];
      this.searchEmployeed = "";
      this.searchTag = "";
    },
    removeTag(tag) {
      this.selectedTagsGroup = this.selectedTagsGroup.filter(
        (item) => item !== tag.id
      );
    },
    validateAndSave() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.saveSelectedTags();
        this.showAlert(this.$tc("gestionEmpleados.addTagSuccess"), "#82A1D0");
      }
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    saveSelectedTags() {
      let payload = {
        empId: this.selectedRow,
        etiquetas: this.selectedTagsGroup,
      };
      this.$store.commit("tags/setNewTag", payload);
      this.$store.dispatch("tags/addTagsEmpGroup").then(() => {
        this.cancelDialogTag();
        this.$store.dispatch("employees/getEmployeesPaginate");
      });
    },
    changesLabels() {
      let filteredItems = this.getEmployees?.filter((item) => {
        return this.selected?.every((selectedId) => {
          return item.labels?.some((label) => {
            return label.etiquetaId === selectedId;
          });
        });
      });
      return filteredItems;
    },
    async goToMonthlyRecord(item) {
      item.fecDesde = this.calendarDate;
      await this.$store.dispatch("employees/getMontlyTab", item).then(() => {
        this.showMonthlyRecord = true;
      });
    },
    closeDialog() {
      this.thereIsNoInterfaceDevice = false;
      this.showUserNotExist = false;
      this.showFormEnrollment = false;
      this.loading = false;
      this.showMonthlyRecord = false;
      this.calendarDate = moment().startOf("month").format("YYYY-MM-DD");
    },
    setFilter(value) {
      if (value === "activos") {
        this.selectedActive = true;
        this.dispatchOnlyActive();
      } else {
        this.$store.commit("employees/setOnlyActive", false);
        this.selectedActive = false;
      }
      this.$store.commit("employees/setSelectedFilter", value);
    },
    async dispatchOnlyActive() {
      this.loading = true;
      this.$store.commit("employees/setOnlyActive", true);
      this.$store.commit("employees/setSelectedFilter", null);
      this.$store.commit("employees/setLimit", 44);
      this.$store.commit("employees/setWhere", {});
      await this.$store.dispatch("employees/getEmployeesPaginate");
      this.loading = false;
    },
    async applyFilter() {
      this.loading = true;
      if (!this.selectedFilter || !this.filterValue.trim()) {
        return;
      }
      let where = {};
      if (this.selectedFilter === "nombre+apellido") {
        const [nombre, apellido] = this.filterValue.trim().split(" ");
        if (nombre) where.nombre = nombre;
        if (apellido) where.apellido = apellido;
      } else {
        where = {
          [this.selectedFilter]: this.filterValue.trim(),
        };
      }
      await this.$store.dispatch("employees/updateWhere", where);
      this.loading = false;
    },
    async resetFilter() {
      this.loading = true;
      this.$store.commit("employees/setOnlyActive", false);
      this.$store.commit("employees/setFilterValue", "");
      this.$store.commit("employees/setSelectedFilter", null);
      this.$store.commit("employees/setLimit", 44);
      this.$store.commit("employees/setWhere", {});
      await this.$store.dispatch("employees/getEmployeesPaginate");
      this.loading = false;
    },
    async refreshItems() {
      this.loading4 = true;
      try {
        await this.$emit("refreshItems");
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },
    employeeState(employed) {
      if (employed.downDate === null) {
        return true;
      }
      const today = moment();
      const downDate = moment(employed.downDate);
      return downDate.isSameOrAfter(today);
    },
    stateColor(employed) {
      const isActive = this.employeeState(employed);
      return isActive ? "green" : "red";
    },
    stateIcon(employed) {
      const isActive = this.employeeState(employed);
      return {
        icon: isActive ? "fas fa-user-check" : "fas fa-user-times",
      };
    },
    stateTooltip(employed) {
      const isActive = this.employeeState(employed);
      return isActive
        ? this.$tc("gestionEmpleados.active")
        : this.$tc("gestionEmpleados.inactive");
    },
    cancelChanged() {
      this.thereIsNoInterfaceDevice = false;
      this.showUserNotExist = false;
      this.showFormEnrollment = false;
      this.loading = false;
      this.showDialog = false;
      this.employedChanged = null;
    },
    confirmChanged() {
      if (this.employedChanged !== null) {
        this.$store.commit("employees/setEditEmployed", this.employedChanged);
        if (this.employedChanged.isEnabled) {
          this.$store.commit(
            "employees/setIsEnabled",
            !this.employedChanged.isEnabled
          );
          this.$store.dispatch("employees/disabledEmployed");
          this.showDialog = false;
        } else {
          this.$store.commit(
            "employees/setIsEnabled",
            !this.employedChanged.isEnabled
          );
          this.$store.dispatch("employees/enabledEmployed");
          this.showDialog = false;
        }
      }
    },

    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        this.showAlert(this.$tc("commons.savedColumnSetting"), "#82A1D0");
        configTable.commit("setNew", []);
      });
    },
    employedSelected(value) {
      localStorage.setItem("empId", value.empId);
      this.$router.push(`/GestionEmpleados/info/${value.empId}`);
      this.$store.commit("employees/setItemsEmployed", value);
    },
    openDialog() {
      this.formKey++;
      this.showAdd = true;
      this.$store.commit("employees/setShowAdd", true);
      this.$store.dispatch("changeGroup/getGroups");
      this.$store.dispatch("changeSchedule/getSchedules");
      this.$store.dispatch("assignCards/getCardsAssign");
      this.$store.dispatch("gestionTiempos/getModels");
    },
    toggleColumnMenu() {
      this.btnConfigColumns.menu = !this.btnConfigColumns.menu;
    },
    saveColumnOrder(newIndex, oldIndex) {
      const visibleHeaders = this.allHeaders.filter((header) => header.visible);
      const movedColumn = visibleHeaders.splice(oldIndex, 1)[0];
      visibleHeaders.splice(newIndex, 0, movedColumn);
      const newHeaders = [];
      let visibleIndex = 0;
      for (const header of this.allHeaders) {
        if (header.visible) {
          newHeaders.push(visibleHeaders[visibleIndex]);
          visibleIndex++;
        } else {
          newHeaders.push(header);
        }
      }
      configTable.commit("setColums", newHeaders);
      this.tableKey++;
      this.$forceUpdate();
    },
  },
  directives: {
    sortableColumns: {
      inserted(el, binding) {
        const table = el.querySelector("table");
        const headerRow = table.querySelector("thead tr");
        const sortableHeaders = Array.from(headerRow.children);
        const options = {
          animation: 150,
          ghostClass: "sortable-ghost",
          onEnd: function (event) {
            const newIndex = event.newIndex;
            const oldIndex = event.oldIndex;
            binding.value(newIndex, oldIndex);
          },
        };
        Sortable.create(headerRow, options);
      },
    },
  },
};
</script>

<style scoped>
.add-tag {
  position: relative;
  top: -40px;
  left: 350px;
}
.draggable-item {
  cursor: grab;
  user-select: none;
}
.draggable-item:active {
  cursor: grabbing;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.search {
  max-width: 500px !important;
}
.autocomplete {
  padding: 0px;
  margin: 0px;
  max-width: 290px !important;
}

#chip-tag {
  color: #ffffff;
  text-shadow: 0px 1px 4px #000000be;
}

#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
  max-height: 75vh;
}
.filter-search-container {
  display: flex;
  align-items: center;
  border-radius: 15px;
  background-color: #a5b9d7;
}

.filter-container {
  display: inline-block;
}

.search-container {
  flex-grow: 1;
}
.hover-effect:hover .hover-icon {
  color: #39537a; /* Azul de Vuetify */
  transform: scale(1.2); /* Aumenta ligeramente el tamaño */
  transition: all 0.2s ease-in-out;
}
</style>
